export default __webpack_public_path__ + "static/media/Produit.7a102786.svg";